export const EVENTS = {
  CLICK_EVENT_TILE: 'click_event_tile',
  CLICK_CREATE: 'click_create',
  CLICK_VERIFY_PIN_CODE: 'click_verify_pin_code',
  SCREEN_ADD_EVENT_DETAILS: 'screen_add_event_details',
  SCREEN_GOLD_UPSELL: 'screen_gold_upsell',
  CLICK_GOLD_UPSELL_YES: 'click_gold_upsell_yes',
  CLICK_GOLD_UPSELL_NO: 'click_gold_upsell_no',
  SCREEN_BUNDLE_UPSELL: 'screen_bundle_upsell',
  CLICK_CONTINUE: 'click_continue',
  CLICK_SKIP: 'click_skip',
  CLICK_GET_DEAL: 'click_get_deal',
  CLICK_NO_THANKS: 'click_no_thanks',
};
